import RpcClass from "../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.Forms';

import LocalDate from "../../../../server/LocalDate.js";
import LocalDateTime from "../../../../server/LocalDateTime.js";
import LocalTime from "../../../../server/LocalTime.js";



class Forms extends RpcClass{

    /**
     *  @class Forms
     *  @alias module:src/server/com/silkplm/rpc/Forms.Forms
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param clazz {string} 
     * @param rawData {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcException.RpcException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/ComplexNewRecordError.ComplexNewRecordError>}
     */
     addComplexEntity(clazz, rawData) {
            return RpcClass.rpcCall('/rpc/forms/add-complex-entity', [clazz, rawData]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param rawData {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcException.RpcException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     addEntities(clazz, rawData) {
            return RpcClass.rpcCall('/rpc/forms/add-entities', [clazz, rawData]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param rawData {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcException.RpcException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     addEntity(clazz, rawData) {
            return RpcClass.rpcCall('/rpc/forms/add-entity', [clazz, rawData]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param entityId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     beforeDeleteDynamicEntityDialog(clazz, entityId) {
            return RpcClass.rpcCall('/rpc/forms/before-delete-dynamic-entity-dialog', [clazz, entityId]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param ids {string[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     beforeDeleteDynamicEntityDialogBulkDelete(clazz, ids) {
            return RpcClass.rpcCall('/rpc/forms/before-delete-dynamic-entity-dialog-bulk-delete', [clazz, ids]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param entityId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     beforeDeleteEntityDialog(clazz, entityId) {
            return RpcClass.rpcCall('/rpc/forms/before-delete-entity-dialog', [clazz, entityId]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param ids {number[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     beforeDeleteEntityDialogBulkDelete(clazz, ids) {
            return RpcClass.rpcCall('/rpc/forms/before-delete-entity-dialog-bulk-delete', [clazz, ids]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param masterId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     canAdd(clazz, masterId) {
            return RpcClass.rpcCall('/rpc/forms/can-add', [clazz, masterId]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param entityId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/CanDeleteEntityWithInfo.CanDeleteEntityWithInfo>}
     */
     canDeleteDynamicEntity(clazz, entityId) {
            return RpcClass.rpcCall('/rpc/forms/can-delete-dynamic-entity', [clazz, entityId]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param entityId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/CanDeleteEntityWithInfo.CanDeleteEntityWithInfo>}
     */
     canDeleteEntity(clazz, entityId) {
            return RpcClass.rpcCall('/rpc/forms/can-delete-entity', [clazz, entityId]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param rawData {string} 
     * @param optionalParentFormClass {string} 
     * @param parentId {string} 
     * @param siblings {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcException.RpcException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/InputValidationResult.InputValidationResult>}
     */
     checkConstraints(clazz, rawData, optionalParentFormClass, parentId, siblings) {
            return RpcClass.rpcCall('/rpc/forms/check-constraints', [clazz, rawData, optionalParentFormClass, parentId, siblings]);
    }
    /** 
     * @async
     * @param className {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     countAllEntitiesByClassName(className) {
            return RpcClass.rpcCall('/rpc/forms/count-all-entities-by-class-name', [className]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param ListOfEntitiesId {string[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     deleteDynamicEntities(clazz, ListOfEntitiesId) {
            return RpcClass.rpcCall('/rpc/forms/delete-dynamic-entities', [clazz, ListOfEntitiesId]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param entityId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     deleteDynamicEntity(clazz, entityId) {
            return RpcClass.rpcCall('/rpc/forms/delete-dynamic-entity', [clazz, entityId]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param ListOfEntitiesId {number[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     deleteEntities(clazz, ListOfEntitiesId) {
            return RpcClass.rpcCall('/rpc/forms/delete-entities', [clazz, ListOfEntitiesId]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param entityId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     deleteEntity(clazz, entityId) {
            return RpcClass.rpcCall('/rpc/forms/delete-entity', [clazz, entityId]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param entityId {string} 
     * @param replacingId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     deleteEntityWithReplacement(clazz, entityId, replacingId) {
            return RpcClass.rpcCall('/rpc/forms/delete-entity-with-replacement', [clazz, entityId, replacingId]);
    }
    /** 
     * @async
     * @param formId {number} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     dynamicFormIdToClass(formId) {
            return RpcClass.rpcCall('/rpc/forms/dynamic-form-id-to-class', [formId]);
    }
    /** 
     * @async
     * @param listOfIds {number[]} 
     * @param fieldName {string} 
     * @param rawData {string} 
     * @param clazz {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcException.RpcException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/db/model/DataEntity.DataEntity[]>}
     */
     editEntities(listOfIds, fieldName, rawData, clazz) {
            return RpcClass.rpcCall('/rpc/forms/edit-entities', [listOfIds, fieldName, rawData, clazz]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param rawData {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcException.RpcException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>}
     */
     editEntity(clazz, rawData) {
            return RpcClass.rpcCall('/rpc/forms/edit-entity', [clazz, rawData]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param rawData {string} 
     * @param fields {string[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcException.RpcException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>}
     */
     editEntityFields(clazz, rawData, fields) {
            return RpcClass.rpcCall('/rpc/forms/edit-entity-fields', [clazz, rawData, fields]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>}
     */
     findOne(clazzName) {
            return RpcClass.rpcCall('/rpc/forms/find-one', [clazzName]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>}
     */
     getDefaultValueForSelect(clazzName) {
            return RpcClass.rpcCall('/rpc/forms/get-default-value-for-select', [clazzName]);
    }
    /** 
     * @async
     * @param masterClass {string} 
     * @param detailsClass {string} 
     * @param rawMasterInstance {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord[]>}
     */
     getDetails(masterClass, detailsClass, rawMasterInstance) {
            return RpcClass.rpcCall('/rpc/forms/get-details', [masterClass, detailsClass, rawMasterInstance]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param uuid {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     getDynamicEntityLabel(clazzName, uuid) {
            return RpcClass.rpcCall('/rpc/forms/get-dynamic-entity-label', [clazzName, uuid]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param entityId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>}
     */
     getEntity(clazzName, entityId) {
            return RpcClass.rpcCall('/rpc/forms/get-entity', [clazzName, entityId]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param eid {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>}
     */
     getEntityByEid(clazzName, eid) {
            return RpcClass.rpcCall('/rpc/forms/get-entity-by-eid', [clazzName, eid]);
    }
    /** 
     * @async
     * @param baseClazz {string} 
     * @param entityId {string} 
     * @param joiningField {string} 
     * @param extensionClass {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>}
     */
     getEntityExtension(baseClazz, entityId, joiningField, extensionClass) {
            return RpcClass.rpcCall('/rpc/forms/get-entity-extension', [baseClazz, entityId, joiningField, extensionClass]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param entityId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     getEntityLabel(clazzName, entityId) {
            return RpcClass.rpcCall('/rpc/forms/get-entity-label', [clazzName, entityId]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param entityId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/fasterxml/jackson/core/TreeNode.TreeNode>}
     */
     getExtendedDynamicEntity(clazz, entityId) {
            return RpcClass.rpcCall('/rpc/forms/get-extended-dynamic-entity', [clazz, entityId]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param entityId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>}
     */
     getExtendedEntity(clazz, entityId) {
            return RpcClass.rpcCall('/rpc/forms/get-extended-entity', [clazz, entityId]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param eid {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>}
     */
     getExtendedEntityByEid(clazz, eid) {
            return RpcClass.rpcCall('/rpc/forms/get-extended-entity-by-eid', [clazz, eid]);
    }
    /** 
     * @async
     * @param baseClazz {string} 
     * @param entityId {string} 
     * @param joiningField {string} 
     * @param extensionClass {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>}
     */
     getExtendedEntityExtension(baseClazz, entityId, joiningField, extensionClass) {
            return RpcClass.rpcCall('/rpc/forms/get-extended-entity-extension', [baseClazz, entityId, joiningField, extensionClass]);
    }
    /** 
     * @async
     * @param formName {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/forms/schema/BaseFormConfig.BaseFormConfig>}
     */
     getFormByClassName(formName) {
            return RpcClass.rpcCall('/rpc/forms/get-form-by-class-name', [formName]);
    }
    /** 
     * @async
     * @param formId {number} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/forms/schema/BaseFormConfig.BaseFormConfig>}
     */
     getFormByFormId(formId) {
            return RpcClass.rpcCall('/rpc/forms/get-form-by-form-id', [formId]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/forms/schema/BaseFormConfig.BaseFormConfig[]>}
     */
     getForms() {
            return RpcClass.rpcCall('/rpc/forms/get-forms', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Object.<string, string>>}
     */
     getLabelDictionaries() {
            return RpcClass.rpcCall('/rpc/forms/get-label-dictionaries', []);
    }
    /** 
     * @async
     * @param link {module:src/server/com/silkplm/engine/forms/schema/definition/ComputedLink.ComputedLink} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/forms/schema/definition/ComputedLink.ComputedLink>}
     */
     getParentLink(link) {
            return RpcClass.rpcCall('/rpc/forms/get-parent-link', [link]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param field {string} 
     * @param rawInstance {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Object.<*, string>>}
     */
     getSelectOptions(clazz, field, rawInstance) {
            return RpcClass.rpcCall('/rpc/forms/get-select-options', [clazz, field, rawInstance]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param entityId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string[]>}
     */
     getTreePath(clazzName, entityId) {
            return RpcClass.rpcCall('/rpc/forms/get-tree-path', [clazzName, entityId]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param entityId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord[]>}
     */
     getTreePathElements(clazzName, entityId) {
            return RpcClass.rpcCall('/rpc/forms/get-tree-path-elements', [clazzName, entityId]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param id {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     hasWriteAccessToInstance(clazz, id) {
            return RpcClass.rpcCall('/rpc/forms/has-write-access-to-instance', [clazz, id]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param rawData {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcException.RpcException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>}
     */
     hideEntity(clazz, rawData) {
            return RpcClass.rpcCall('/rpc/forms/hide-entity', [clazz, rawData]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param rawValue {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     initializeNewRecord(clazz, rawValue) {
            return RpcClass.rpcCall('/rpc/forms/initialize-new-record', [clazz, rawValue]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param masterId {string} 
     * @param detailClass {string} 
     * @param joiningField {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*[]>}
     */
     listDetails(clazzName, masterId, detailClass, joiningField) {
            return RpcClass.rpcCall('/rpc/forms/list-details', [clazzName, masterId, detailClass, joiningField]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param masterId {string} 
     * @param detailClass {string} 
     * @param joiningField {string} 
     * @param colFiltersSpecs {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*[]>}
     */
     listDetailsWithColsFilter(clazzName, masterId, detailClass, joiningField, colFiltersSpecs) {
            return RpcClass.rpcCall('/rpc/forms/list-details-with-cols-filter', [clazzName, masterId, detailClass, joiningField, colFiltersSpecs]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param masterId {string} 
     * @param detailClass {string} 
     * @param joiningField {string} 
     * @param colFiltersSpecs {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/SummaryRow.SummaryRow>}
     */
     listDetailsWithColsFilterWithSummary(clazzName, masterId, detailClass, joiningField, colFiltersSpecs) {
            return RpcClass.rpcCall('/rpc/forms/list-details-with-cols-filter-with-summary', [clazzName, masterId, detailClass, joiningField, colFiltersSpecs]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param masterId {string} 
     * @param detailClass {string} 
     * @param joiningField {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/SummaryRow.SummaryRow>}
     */
     listDetailsWithSummary(clazzName, masterId, detailClass, joiningField) {
            return RpcClass.rpcCall('/rpc/forms/list-details-with-summary', [clazzName, masterId, detailClass, joiningField]);
    }
    /** 
     * @async
     * @param clazzNameForeignKey {string} 
     * @param detailsClass {string} 
     * @param rawData {string} 
     * @param masterId {string} 
     * @param masterClass {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord[]>}
     */
     listDictionaryForMultipleAdd(clazzNameForeignKey, detailsClass, rawData, masterId, masterClass) {
            return RpcClass.rpcCall('/rpc/forms/list-dictionary-for-multiple-add', [clazzNameForeignKey, detailsClass, rawData, masterId, masterClass]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param fieldName {string} 
     * @param rawData {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord[]>}
     */
     listDictionaryValues(clazzName, fieldName, rawData) {
            return RpcClass.rpcCall('/rpc/forms/list-dictionary-values', [clazzName, fieldName, rawData]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param parentFieldId {string} 
     * @param fieldName {string} 
     * @param rawData {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord[]>}
     */
     listDictionaryValuesForParent(clazzName, parentFieldId, fieldName, rawData) {
            return RpcClass.rpcCall('/rpc/forms/list-dictionary-values-for-parent', [clazzName, parentFieldId, fieldName, rawData]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param parentFieldId {string} 
     * @param fieldName {string} 
     * @param rawData {string} 
     * @param region {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord[]>}
     */
     listDictionaryValuesForParentWithRegion(clazzName, parentFieldId, fieldName, rawData, region) {
            return RpcClass.rpcCall('/rpc/forms/list-dictionary-values-for-parent-with-region', [clazzName, parentFieldId, fieldName, rawData, region]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param fieldName {string} 
     * @param rawData {string} 
     * @param region {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord[]>}
     */
     listDictionaryValuesWithRegion(clazzName, fieldName, rawData, region) {
            return RpcClass.rpcCall('/rpc/forms/list-dictionary-values-with-region', [clazzName, fieldName, rawData, region]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/fasterxml/jackson/core/TreeNode.TreeNode[]>}
     */
     listDynamicExtendedEntities(clazzName) {
            return RpcClass.rpcCall('/rpc/forms/list-dynamic-extended-entities', [clazzName]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord[]>}
     */
     listEntities(clazzName) {
            return RpcClass.rpcCall('/rpc/forms/list-entities', [clazzName]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param colFiltersSpecs {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string[]>}
     */
     listEntitiesIdsWithColFilters(clazzName, colFiltersSpecs) {
            return RpcClass.rpcCall('/rpc/forms/list-entities-ids-with-col-filters', [clazzName, colFiltersSpecs]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param fieldName {string} 
     * @param rawData {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord[]>}
     */
     listExtendedDictionaryValues(clazzName, fieldName, rawData) {
            return RpcClass.rpcCall('/rpc/forms/list-extended-dictionary-values', [clazzName, fieldName, rawData]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param fieldName {string} 
     * @param rawData {string} 
     * @param colFiltersSpecs {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord[]>}
     */
     listExtendedDictionaryValues(clazzName, fieldName, rawData, colFiltersSpecs) {
            return RpcClass.rpcCall('/rpc/forms/list-extended-dictionary-values', [clazzName, fieldName, rawData, colFiltersSpecs]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param parentFieldId {string} 
     * @param fieldName {string} 
     * @param rawData {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord[]>}
     */
     listExtendedDictionaryValuesForParent(clazzName, parentFieldId, fieldName, rawData) {
            return RpcClass.rpcCall('/rpc/forms/list-extended-dictionary-values-for-parent', [clazzName, parentFieldId, fieldName, rawData]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param fieldName {string} 
     * @param rawData {string} 
     * @param region {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord[]>}
     */
     listExtendedDictionaryValuesWithRegion(clazzName, fieldName, rawData, region) {
            return RpcClass.rpcCall('/rpc/forms/list-extended-dictionary-values-with-region', [clazzName, fieldName, rawData, region]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord[]>}
     */
     listExtendedEntities(clazzName) {
            return RpcClass.rpcCall('/rpc/forms/list-extended-entities', [clazzName]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param ids {number[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord[]>}
     */
     listExtendedEntitiesByListOfIds(clazzName, ids) {
            return RpcClass.rpcCall('/rpc/forms/list-extended-entities-by-list-of-ids', [clazzName, ids]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param filterId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord[]>}
     */
     listExtendedEntitiesClustered(clazzName, filterId) {
            return RpcClass.rpcCall('/rpc/forms/list-extended-entities-clustered', [clazzName, filterId]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param filterId {string} 
     * @param colFiltersSpecs {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord[]>}
     */
     listExtendedEntitiesClusteredWithColFilters(clazzName, filterId, colFiltersSpecs) {
            return RpcClass.rpcCall('/rpc/forms/list-extended-entities-clustered-with-col-filters', [clazzName, filterId, colFiltersSpecs]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param filterId {string} 
     * @param colFiltersSpecs {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/SummaryRow.SummaryRow>}
     */
     listExtendedEntitiesClusteredWithColFiltersWithSummary(clazzName, filterId, colFiltersSpecs) {
            return RpcClass.rpcCall('/rpc/forms/list-extended-entities-clustered-with-col-filters-with-summary', [clazzName, filterId, colFiltersSpecs]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param filterId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/SummaryRow.SummaryRow>}
     */
     listExtendedEntitiesClusteredWithSummary(clazzName, filterId) {
            return RpcClass.rpcCall('/rpc/forms/list-extended-entities-clustered-with-summary', [clazzName, filterId]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param colFiltersSpecs {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord[]>}
     */
     listExtendedEntitiesWithColFilters(clazzName, colFiltersSpecs) {
            return RpcClass.rpcCall('/rpc/forms/list-extended-entities-with-col-filters', [clazzName, colFiltersSpecs]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param colFiltersSpecs {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/SummaryRow.SummaryRow>}
     */
     listExtendedEntitiesWithColFiltersWithSummary(clazzName, colFiltersSpecs) {
            return RpcClass.rpcCall('/rpc/forms/list-extended-entities-with-col-filters-with-summary', [clazzName, colFiltersSpecs]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param fieldName {string} 
     * @param filterClazz {string} 
     * @param filteringInstance {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord[]>}
     */
     listExtendedEntitiesWithFiltering(clazzName, fieldName, filterClazz, filteringInstance) {
            return RpcClass.rpcCall('/rpc/forms/list-extended-entities-with-filtering', [clazzName, fieldName, filterClazz, filteringInstance]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param fieldName {string} 
     * @param filterClazz {string} 
     * @param filteringInstance {string} 
     * @param colFiltersSpecs {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord[]>}
     */
     listExtendedEntitiesWithFilteringWithColFilters(clazzName, fieldName, filterClazz, filteringInstance, colFiltersSpecs) {
            return RpcClass.rpcCall('/rpc/forms/list-extended-entities-with-filtering-with-col-filters', [clazzName, fieldName, filterClazz, filteringInstance, colFiltersSpecs]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param fieldName {string} 
     * @param filterClazz {string} 
     * @param filteringInstance {string} 
     * @param colFiltersSpecs {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/SummaryRow.SummaryRow>}
     */
     listExtendedEntitiesWithFilteringWithColFiltersWithSummary(clazzName, fieldName, filterClazz, filteringInstance, colFiltersSpecs) {
            return RpcClass.rpcCall('/rpc/forms/list-extended-entities-with-filtering-with-col-filters-with-summary', [clazzName, fieldName, filterClazz, filteringInstance, colFiltersSpecs]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param fieldName {string} 
     * @param filterClazz {string} 
     * @param filteringInstance {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/SummaryRow.SummaryRow>}
     */
     listExtendedEntitiesWithFilteringWithSummary(clazzName, fieldName, filterClazz, filteringInstance) {
            return RpcClass.rpcCall('/rpc/forms/list-extended-entities-with-filtering-with-summary', [clazzName, fieldName, filterClazz, filteringInstance]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param colFiltersSpecs {string} 
     * @param fields {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Object.<string, *>[]>}
     */
     listExtendedEntitiesWithSelectedFields(clazzName, colFiltersSpecs, fields) {
            return RpcClass.rpcCall('/rpc/forms/list-extended-entities-with-selected-fields', [clazzName, colFiltersSpecs, fields]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/SummaryRow.SummaryRow>}
     */
     listExtendedEntitiesWithSummary(clazzName) {
            return RpcClass.rpcCall('/rpc/forms/list-extended-entities-with-summary', [clazzName]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/forms/TreeElementInfo.TreeElementInfo[]>}
     */
     listExtendedTreeEntities(clazzName) {
            return RpcClass.rpcCall('/rpc/forms/list-extended-tree-entities', [clazzName]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param fieldName {string} 
     * @param filterClazz {string} 
     * @param filteringInstance {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/forms/TreeElementInfo.TreeElementInfo[]>}
     */
     listExtendedTreeEntitiesWithFiltering(clazzName, fieldName, filterClazz, filteringInstance) {
            return RpcClass.rpcCall('/rpc/forms/list-extended-tree-entities-with-filtering', [clazzName, fieldName, filterClazz, filteringInstance]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param filterId {string} 
     * @param colFiltersSpecs {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<com.fasterxml.jackson.databind.node.ObjectNode[]>}
     */
     listView(clazzName, filterId, colFiltersSpecs) {
            return RpcClass.rpcCall('/rpc/forms/list-view', [clazzName, filterId, colFiltersSpecs]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param filterId {string} 
     * @param colFiltersSpecs {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/SummaryRow.SummaryRow>}
     */
     listViewWithSummary(clazzName, filterId, colFiltersSpecs) {
            return RpcClass.rpcCall('/rpc/forms/list-view-with-summary', [clazzName, filterId, colFiltersSpecs]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param rawData {string} 
     * @param versionTag {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcException.RpcException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Object>}
     */
     mergingEditDynamicEntity(clazz, rawData, versionTag) {
            let rawPromise;
            let p = new Promise(function (resolve, reject) {
                rawPromise = RpcClass.rpcCall('/rpc/forms/merging-edit-dynamic-entity', [clazz, rawData, versionTag]);
                rawPromise.then(rawValue => {
                    let v = null;
                    if(rawValue == null){
                        resolve(v);
                        return;
                    }
                    v = rawValue
                    resolve(v);
                }).catch(e => {reject(e)})
            });
            p.onProgress = function(callback){
                rawPromise.onProgress(callback);
                return p;
            }
            return p;
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param rawData {string} 
     * @param versionTag {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcException.RpcException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>}
     */
     mergingEditEntity(clazz, rawData, versionTag) {
            return RpcClass.rpcCall('/rpc/forms/merging-edit-entity', [clazz, rawData, versionTag]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param rawData {string} 
     * @param fields {string[]} 
     * @param versionTag {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcException.RpcException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>}
     */
     mergingEditEntityFields(clazz, rawData, fields, versionTag) {
            return RpcClass.rpcCall('/rpc/forms/merging-edit-entity-fields', [clazz, rawData, fields, versionTag]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param rawValue {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/entities/BusinessRecord.BusinessRecord>}
     */
     refreshComputedFields(clazz, rawValue) {
            return RpcClass.rpcCall('/rpc/forms/refresh-computed-fields', [clazz, rawValue]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param baseField {string} 
     * @param newFieldValue {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Object.<string, *>>}
     */
     refreshJoinedFields(clazz, baseField, newFieldValue) {
            return RpcClass.rpcCall('/rpc/forms/refresh-joined-fields', [clazz, baseField, newFieldValue]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     runtimeJsScript() {
            return RpcClass.rpcCall('/rpc/forms/runtime-js-script', []);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param fieldName {string} 
     * @param rawFieldData {string} 
     * @param id {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcException.RpcException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/FieldValidationResult.FieldValidationResult>}
     */
     validateField(clazz, fieldName, rawFieldData, id) {
            return RpcClass.rpcCall('/rpc/forms/validate-field', [clazz, fieldName, rawFieldData, id]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.Forms';
metadata.__type_short__ = 'Forms';
Forms.prototype.__metadata__ = metadata;

Forms.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/Forms */
export default Forms

export { Forms }
